
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getSendMessagePersonalDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    sendPushnotification: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    sendFromNeutralAccount: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    selectedPhoneNumbers: new FormControl<Array<string> | undefined>([], [Validators.required]),
    selectedMailAdresses: new FormControl<Array<string> | undefined>([], [Validators.required]),
    pushNbDevices: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      